<template>
    <div class="auth-wrapper">
        <div class="auth-header__menu main-clear">
            <router-link  :to="{name:'Auth'}" class="prev-page" title="Назад"></router-link>
        </div>
        <div class="auth-content">
            <div class="auth-area">
                <Logo/>
                <Login/>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Login from '@/components/auth/Login.vue'
    import Logo from '@/views/auth/Logo.vue'
    import Footer from "@/views/auth/Footer";

    export default {
        name: 'Auth',
        metaInfo () {
            return {
                title: '"ИС-НЕЙВА", авторизация',
            }
        },
        components: {
            Footer,
            Logo,
            Login
        }
    }
</script>
